module.exports = __webpack_public_path__ + "static/media/gallery (9).d766cea7.jpeg";